export interface LocationCoordinates {
  latitude: number
  longitude: number
}

export interface LocationValue extends LocationCoordinates {
  name?: string | undefined
  address: string
  locationLabel?: string | undefined
  mapProvider: string
  providerPlaceId?: string | undefined
  metadata?: Record<string, unknown> | undefined
}

export function isValidLocationCoordinates(value: unknown): value is LocationCoordinates {
  if (!value || typeof value !== 'object') return false
  const point = value as Partial<LocationCoordinates>
  return typeof point.latitude === 'number' && Number.isFinite(point.latitude) && Math.abs(point.latitude) <= 90
    && typeof point.longitude === 'number' && Number.isFinite(point.longitude) && Math.abs(point.longitude) <= 180
}
